import { CommonModule } from '@angular/common';
import { Component, OnInit, inject, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { ApiClientService } from '../core/api-client.service';

@Component({
  standalone: true,
  selector: 'app-facebook-social-callback',
  imports: [CommonModule],
  template: `
    <main class="callback-shell">
      @if(loading()) {
        <span class="spinner" aria-hidden="true"></span>
        <h1>Meta hesabı bağlanıyor</h1>
        <p>Seçtiğiniz hesaplar hazırlanıyor.</p>
      } @else if(success()) {
        <span class="success" aria-hidden="true">✓</span>
        <h1>Bağlantı tamamlandı</h1>
        <p>Bu pencereyi kapatabilirsiniz.</p>
        <a href="/app">Aymudo App'e dön</a>
      } @else {
        <span class="failure" aria-hidden="true">!</span>
        <h1>Bağlantı tamamlanamadı</h1>
        <p>{{error()}}</p>
        @if(retryable()) { <button type="button" (click)="retry()" [disabled]="loading()">Yeniden kontrol et</button> }
        <a href="/app">Aymudo App'e dön</a>
      }
    </main>
  `,
  styles: [`
    .callback-shell{display:grid;place-items:center;align-content:center;gap:14px;box-sizing:border-box;min-height:100vh;padding:28px;background:var(--background,#f8f5ef);color:var(--text,#14211d);text-align:center}.callback-shell h1{margin:0;font-family:var(--font-display,Georgia,serif);font-size:clamp(2.1rem,7vw,4.5rem);line-height:1}.callback-shell p{margin:0;color:var(--muted,#68706c);font-size:1.05rem}.callback-shell a,.callback-shell button{margin-top:10px;padding:13px 20px;border:0;border-radius:999px;background:var(--accent,#2e978a);color:var(--accent-contrast,#fff);font:inherit;font-weight:800;text-decoration:none;cursor:pointer}.callback-shell button:disabled{opacity:.55;cursor:wait}.spinner{width:45px;height:45px;border:4px solid color-mix(in srgb,var(--accent,#2e978a) 20%,transparent);border-top-color:var(--accent,#2e978a);border-radius:50%;animation:spin .8s linear infinite}.success,.failure{display:grid;place-items:center;width:54px;height:54px;border-radius:50%;font-size:28px;font-weight:900}.success{background:#daf5e5;color:#167a44}.failure{background:#ffe0dc;color:#bc4038}@keyframes spin{to{transform:rotate(360deg)}}
  `]
})
export class FacebookSocialCallbackPage implements OnInit {
  private readonly route=inject(ActivatedRoute);
  private readonly api=inject(ApiClientService);
  protected readonly loading=signal(true);
  protected readonly success=signal(false);
  protected readonly error=signal('Meta yetkilendirmesi doğrulanamadı.');
  protected readonly retryable=signal(false);

  ngOnInit(){if(typeof window!=='undefined')void this.complete();}

  private async complete(){
    const params=this.route.snapshot.queryParamMap;
    const code=params.get('code')||'';
    const providerError=params.get('error_description')||params.get('error_message')||params.get('error')||'';
    if(providerError||!code){this.error.set(providerError||'Meta doğrulama kodu bulunamadı.');this.loading.set(false);return;}
    try{
      const response:any=await firstValueFrom(this.api.post('/api/app/operation',{operationKey:'social.connections.oauth-callback',payload:{code}}));
      if(response?.success===false||response?.result===false)throw new Error(response?.message||'Meta bağlantısı tamamlanamadı.');
      this.success.set(true);this.loading.set(false);
      try{if(window.opener&&!window.opener.closed){window.opener.postMessage({type:'socialConnectionConnected'},window.location.origin);window.setTimeout(()=>window.close(),350);return;}}catch{}
      window.setTimeout(()=>window.location.replace('/app'),700);
    }catch(source:any){this.error.set(String(source?.error?.message||source?.message||'Meta bağlantısı tamamlanamadı.'));this.retryable.set(Boolean(source?.error?.retryable));this.loading.set(false);}
  }

  protected async retry(){
    this.loading.set(true);this.retryable.set(false);
    try{
      const response:any=await firstValueFrom(this.api.post('/api/app/operation',{operationKey:'social.connections.oauth-callback',payload:{retryPending:true}}));
      if(response?.success===false||response?.result===false)throw new Error(response?.message||'Meta bağlantısı tamamlanamadı.');
      this.success.set(true);this.loading.set(false);window.setTimeout(()=>window.location.replace('/app'),700);
    }catch(source:any){this.error.set(String(source?.error?.message||source?.message||'Meta bağlantısı tamamlanamadı.'));this.retryable.set(Boolean(source?.error?.retryable));this.loading.set(false);}
  }
}
